import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AddCircleBlue, CheckboxComponentBtn, CheckboxesTags, CustomDelete, Loader, NoItemsYet } from 'components';
import { FindErrorItem, FindLoad, FindSuccess, Images, PermissionList, RolePermission, sortAlphabetically, useModal } from 'utils';
import { adminActions, httpRequestsOnErrorsActions, httpRequestsOnSuccessActions } from 'store';
import { systemItemStyles } from 'fragments/system/core';
import { popperUseStyles } from '../../../management/core/style';
import { staffServiceNotYet } from './constants';

const ACTION_TYPE = 'CREATE_STAFF_SERVICE';
const GET_SERVICE_ACTION_TYPE = 'GET_STAFF_SERVICE';

export const StaffService = ({ staffGeneral, info }) => {
    const { staffServices, staffFsServices } = useSelector((state) => ({
        staffServices: state.admins.staffServices,
        staffFsServices: state.admins.staffFsServices,
    }));
    const classes = systemItemStyles();
    const popperClasses = popperUseStyles();
    const params = useParams();
    const dispatch = useDispatch();
    const createSuccess = FindSuccess(ACTION_TYPE);
    const backError = FindErrorItem(ACTION_TYPE);
    const loadCreate = FindLoad(ACTION_TYPE);
    const getLoader = FindLoad(GET_SERVICE_ACTION_TYPE);
    const [list, setList] = useState([]);
    const [error, setError] = useState('');
    const [show, setShow] = useState(false);
    const { open } = useModal();
    const _isNotClinician = staffGeneral?.clinical === false;

    useEffect(() => {
        dispatch(adminActions.getStaffFsServices());
        dispatch(adminActions.getStaffService(params.id));
    }, []);

    useEffect(() => {
        if (!!createSuccess.length) {
            setShow(false);
            setList([]);
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
        }
    }, [createSuccess.length]);

    const renderStaffServiceRow = (item) => {
        return (
            <div className="flex-align-center" style={{ gap: 16 }}>
                <div className="staff-service-lock-icon">
                    <img src={Images.lock} alt="lock" />
                </div>
                <div className="staff-service-fs">
                    <img src={Images.businessCenter} alt="businessCenter" />
                    <p style={{ fontWeight: 600 }}>{item?.fs ? `${item?.fs} - ` : 'N/A -'}</p>
                    <p>{`${item?.serviceType ? `${item?.serviceType} - ` : 'N/A -'} ${item?.displayCode ? item?.displayCode : 'N/A '}`}</p>
                </div>
                <div className="flex-align-center full-width" style={{ gap: 4 }}>
                    <div className="staff-service-type">
                        {item?.chargeRateTitle && <p style={{ fontWeight: 600 }}>{item?.chargeRateTitle}</p>}
                        {(item?.chargeRateModifier || item?.chargeRateModifier2 || item?.chargeRateModifier3) && (
                            <p>{`(${[item?.chargeRateModifier, item?.chargeRateModifier2, item?.chargeRateModifier3].filter(Boolean).join(', ')}) - `}</p>
                        )}
                    </div>
                    {!!item?.chargeRateCredentials?.length && (
                        <div className="staff-service-modifiers">
                            <p>{item?.chargeRateCredentials?.map((i) => i).join(', ')}</p>
                        </div>
                    )}
                </div>
            </div>
        );
    };

    const handleChange = (values) => {
        setList(values);
        if (!!backError) {
            dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
        }
        error && setError('');
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        e.stopPropagation();
        if (list?.length > 0) {
            let filteredList = [];
            list?.forEach((i) => filteredList.push(i?.id));
            dispatch(adminActions.createStaffService(params.id, filteredList));
            filteredList = [];
        } else {
            setError(!list?.length ? 'serviceType' : '');
        }
    };

    const filteredList = staffFsServices?.length
        ? staffFsServices
              .filter((array_el) => !staffServices?.some((anotherOne_el) => anotherOne_el?.chargeRateId === array_el.chargeRateId))
              .map((i) => ({ ...i, id: i?.chargeRateId }))
        : [];

    const sortByFS = (services) => {
        return [...services].sort((a, b) => {
            if (a.fs < b.fs) return -1;
            if (a.fs > b.fs) return 1;
            return 0;
        });
    };

    if (getLoader?.length) {
        return <Loader />;
    }

    return (
        <div>
            <div style={{ marginBottom: 0 }}>
                <div style={{ marginBottom: 16, width: '100%', position: 'relative' }}>
                    <div className="space-between">
                        {!show &&
                        <div className="flex-align-center only-exception-text" style={{ gap: 8, }}>
                            <img src={Images.toolInfoIcon} alt="toolInfoIcon" />
                            <p>Only exceptions are listed here. All other services remain available.</p>
                        </div>
                        }

                        {RolePermission([PermissionList.STAFF_SERVICE_MANAGE?.code]) && (
                            <div className="header-action-btn" style={{marginBottom: 0}}>
                                <AddCircleBlue
                                    disabled={_isNotClinician}
                                    text={show ? 'Close' : 'Block Services'}
                                    handleClick={() => setShow(!show)}
                                />
                            </div>
                        )}
                    </div>
                    {RolePermission([PermissionList.STAFF_SERVICE_MANAGE?.code]) && show && (
                        <div className={classes.tablePermissionsBodyStyleWrapper}>
                            <div className={classes.tablePermissionsBodyStyle}>
                                <CheckboxesTags
                                    textRow={false}
                                    styles={{ width: '100%' }}
                                    disabled={loadCreate?.length}
                                    name="serviceType"
                                    handleChange={handleChange}
                                    permissionsList={filteredList?.length ? sortAlphabetically(filteredList, 'fs') : []}
                                    value={list}
                                    renderValue={(e) =>
                                        `${e?.fs ? `${e?.fs} - ` : 'N/A -'}
                                          ${e?.serviceType ? `${e?.serviceType} - ` : 'N/A -'} 
                                           ${e?.displayCode ? `${e?.displayCode}` : '--'}`
                                    }
                                    label={'Services*'}
                                    placeholder={'Services'}
                                    uiType={'modalCheckboxSelect'}
                                    notShowError={true}
                                    renderRow={(item) =>
                                        renderStaffServiceRow({
                                            fs: item?.fs,
                                            serviceType: item?.serviceType,
                                            displayCode: item?.displayCode,
                                            chargeRateTitle: item?.chargeRateTitle,
                                            chargeRateModifier: item?.chargeRateModifier,
                                            chargeRateModifier2: item?.chargeRateModifier2,
                                            chargeRateModifier3: item?.chargeRateModifier3,
                                            chargeRateCredentials: item?.chargeRateCredentials,
                                        })
                                    }
                                    CustomPaperComponent={
                                        <div onClick={(e) => e.stopPropagation()} className={popperClasses.footer}>
                                            <div />
                                            <CheckboxComponentBtn
                                                id={'add-staff-service'}
                                                handleClick={handleSubmit}
                                                list={list}
                                                loadCreate={loadCreate}
                                                btnText={'Add Services'}
                                            />
                                        </div>
                                    }
                                />
                            </div>
                        </div>
                    )}
                </div>

                {staffServices?.length ? (
                    <div className="staff-service-table-wrapper">
                        {sortByFS(staffServices).map((item, index) => {
                            return (
                                <div className="staff-service-item-row" key={index}>
                                    {renderStaffServiceRow(item)}
                                    {RolePermission([PermissionList.STAFF_SERVICE_MANAGE?.code]) && (
                                        <button className="reset-btn-no-paddings">
                                            <img
                                                src={Images.remove}
                                                alt="delete"
                                                onClick={() =>
                                                    open(
                                                        <CustomDelete
                                                            text={`Are you sure you want remove service?`}
                                                            info="Remove Service?"
                                                            handleDel={() =>
                                                                dispatch(adminActions.deleteStaffService(params?.id, item?.chargeRateId))
                                                            }
                                                            actionType={'DELETE_STAFF_SERVICE'}
                                                        />
                                                    )
                                                }
                                            />
                                        </button>
                                    )}
                                </div>
                            );
                        })}
                    </div>
                ) : (
                    <div style={{ position: 'relative' }}>
                        <NoItemsYet
                            text={staffServiceNotYet.title}
                            subTitle={staffServiceNotYet.subTitle}
                            image={staffServiceNotYet.image}
                        />
                    </div>
                )}
            </div>
        </div>
    );
};
